import { Component, Input } from '@angular/core';
import { RouterLink } from "@angular/router";

// constants
import { app } from 'config/app.config';

// components
import { Copyright } from '@sideline/sideline-apps-shared';

@Component({
  selector: 'app-public-footer',
  templateUrl: './public-footer.html',
  styleUrl: './public-footer.scss',
  standalone: true,
  imports: [
    Copyright,
    RouterLink,
],
})
export class PublicFooter {

  @Input() display!: boolean;

  // component
  appName: string = app.marketing.names.product;
  appSlogan: string = app.marketing.slogan;
  appVersion: string = app.version;
  marketingSite: string = app.marketing.site;

  // data
  serviceItems: { key: string, value: string}[] = [
    { key: 'Contact Manager', value: this.generateLink('apps/contact-manager', true) },
    { key: 'Event Manager', value: this.generateLink('apps/event-manager', true) },
    { key: 'Reservation Manager', value: this.generateLink('apps/reservations', true) },
  ];
  resourceItems: { key: string, value: string}[] = [
    { key: 'About Us', value: this.generateLink('about', true) },
    { key: 'Contact Us', value: this.generateLink('contact', true) },
    { key: 'Privacy Policy', value: this.generateLink('privacy', true) },
    { key: 'Terms of Service', value: this.generateLink('terms', true) },
  ];

  // ==========================================================================================================================
  //  helpers
  // ==========================================================================================================================

  private generateLink(route:string, isExternalLink: boolean = false) {
    if (isExternalLink) {
      return `${this.marketingSite}/${route}`;
    } else {
      return `/${route}`;
    }
  }

}
